module.exports = __webpack_public_path__ + "img/vip-banner-bg.8f748be7.png";